// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._2rko1sit{border-radius:var(--ds-border-radius,3px)}._18m915vq{overflow-y:hidden}
._1bah1h6o{justify-content:center}
._1bsb1osq{width:100%}
._1e0c1txw{display:flex}
._1reo15vq{overflow-x:hidden}
._2lx21bp4{flex-direction:column}
._4cvr1h6o{align-items:center}
._4t3i1osq{height:100%}
._c71l1osq{max-height:100%}
._kqswh2mm{position:relative}
._p12f1osq{max-width:100%}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-card/dist/esm/card/ui/wrapper/imageContainer-compiled.compiled.css"],"names":[],"mappings":";AACA,WAAW,yCAAyC,CAAC,WAAW,iBAAiB;AACjF,WAAW,sBAAsB;AACjC,WAAW,UAAU;AACrB,WAAW,YAAY;AACvB,WAAW,iBAAiB;AAC5B,WAAW,qBAAqB;AAChC,WAAW,kBAAkB;AAC7B,WAAW,WAAW;AACtB,WAAW,eAAe;AAC1B,WAAW,iBAAiB;AAC5B,WAAW,cAAc","sourcesContent":["\n._2rko1sit{border-radius:var(--ds-border-radius,3px)}._18m915vq{overflow-y:hidden}\n._1bah1h6o{justify-content:center}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1reo15vq{overflow-x:hidden}\n._2lx21bp4{flex-direction:column}\n._4cvr1h6o{align-items:center}\n._4t3i1osq{height:100%}\n._c71l1osq{max-height:100%}\n._kqswh2mm{position:relative}\n._p12f1osq{max-width:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
